module.exports = __webpack_public_path__ + "media/images/site/erik-com-borda-branca-8fffb1600c59a7c1c4b4031bf2562df7.png";